<script>
import Vue from 'vue';
import FormSelect from './Select.vue';

export default {
  // https://twitter.com/_pi0_/status/991014566824820736
  extends: FormSelect,

  computed: {
    options() {
      return [
        'Adidas',
        'Artengo',
        'Babolat',
        'Becker',
        'Dunlop',
        'Fischer',
        'Head',
        'Lacoste',
        'Major',
        'Penn',
        'Prince',
        'Pro Kennex',
        'Rossignol',
        'Slazenger',
        'Snauwaert',
        'Tecnifibre',
        'Völkl',
        'Wilson',
        'Yonex',
      ].map(name => ({
        value: name,
        label: name,
      }));
    },
  },

  beforeCreate() {
    // Fix [Vue warn]: The computed property "options" is already defined as a prop.
    Vue.delete(this.$options.props, 'options');
  },
};
</script>
